<template>
  <div class="oauth-auth-redirect my-5">
    <div class="container">
      <div v-if="loading" class="text-center">
        <b-spinner></b-spinner>
      </div>
      <div v-else class="text-center">
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      processing: false,
      token: null,
    }
  },

  mounted() {
    let error = this.$route.query.error
    let code = this.$route.query.code
    let errorDescription = this.$route.query.error_description
    // window.opener is null on a direct visit, if the popup was blocked, or if the
    // opener closed first -- this used to throw and white-screen with no message.
    if (!window.opener) return

    window.opener.postMessage({
      'a': true,
      'type': 'gt',
      'b': this.encrypt(code),
      'c': error,
      'd': errorDescription,
    }, "*");
  },

  methods: {
  },
}
</script>
  
<style lang="scss" scoped>
.oauth-auth-redirect {
  display: block;
}
</style>